<template>
  <router-link :to="'/campaigns/'+campaign.id" class="card card--campaign">
    <div class="card--campaign__left">
      <div class="card--campaign__logo">
        <img alt="" :src="campaign.acf.merchant_logo">
      </div>
      <div class="card--campaign__date">
        <span>{{ campaign.acf.start_date }}</span>
        <span v-if="campaign.acf.end_date">- {{ campaign.acf.end_date }}</span>
        <span v-else>- <translation en="ongoing" ch="正在进行的"></translation></span>
      </div>
      <div class="card--campaign__rate">
        <translation en="Up to" ch="取决于"></translation> {{ campaign.acf.commission_rate }}
      </div>
      <span v-if="campaign.status === 'joined'" class="btn btn--small card--campaign__button subscribed">
        <translation en="Joined" ch="已加入"></translation>
      </span>
      <span v-else class="btn btn--small card--campaign__button">
        <translation en="More details" ch="更多细节"></translation>
      </span>
    </div>
    <div class="card--campaign__right">
      <div class="card--campaign__cover-photo">
        <img v-if="campaign.acf.cover_image_small" :src="campaign.acf.cover_image_small">
      </div>
      <div class="card--campaign__description" v-html="campaign.acf.merchant_desc_short"></div>
    </div>
  </router-link>
</template>

<script>

import Translation from "@/components/Translation.vue";


export default {
  name: 'CampaignCard',
  components: {
    Translation
  },
  props: {
    campaign: Object
  },
}
</script>

<style lang="scss" scoped>

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";

.card--campaign{
  color: $darkblue;
  position: relative;
  z-index: 4;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  &__left{
    padding-right: 1.2rem;
    display: flex;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    justify-content: center;
    border-right: 1px solid rgba($darkblue, 0.1);
    width: 138px;
    @include bp(sm){
      width: 162px;
    }
    a{
      text-decoration:none;
    }
    .btn{
      width: 100%;
    }
  }
  &__right{
    flex: 1;
    width: 120px;
    padding-left: 1.2rem;
  }
  &__description{
    font-size: 1.35rem;
    line-height: 2.2rem;
    @include bp(sm){
      font-size: 1.45rem;
      line-height: 2.2rem;
    }
  }
  &__date{
    padding: 1rem 1rem;
    font-size: 1.1rem;
    width: 100%;
    border: 1px solid rgba($darkblue, 0.2);
    text-align: center;
    margin-bottom: 5px;
    color:#030c26;
    span{
      width: 100%;
      line-height: 19px;
      display: block;
    }
  }
  &__button {
    background-color:$aqua;
    color: $darkblue;
    &.subscribed{
      background-color: $lime;
      color: white;
      &:hover, &:focus{
        background-color: darken($lime, 5%);
      }
    }
  }
  &__rate{
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 20px;
    color: red;
    padding: 5px 5px 5px 5px;
    text-align: center;
    border: 1px solid rgba(red, 0.5);
    width: 100%;
  }
  &__logo{
    margin-bottom: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 60px;
    padding: 10px;
    border: 1px solid rgba($darkblue, 0.2);
    width: 100%;
    img{
      max-height: 50px;
      max-width: 100%;
    }
  }

  &__cover-photo {
    flex-grow: 1;
    height: 5rem;
    margin-bottom: 0.7rem;
    background-color:#eee;
    @include bp(sm) {
      height: 7.3rem;
      margin-bottom: 1rem;
    }
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
}
</style>
